export const CONSTANTS = {
    PRIVACY_POLICY_LINK: '/privacy-policy',
    SYRASOFT_LOGO_LINK: 'https://www.datocms-assets.com/104147/1690263300-syrasoft-dark-theme-logo.svg',
}